__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/1f06bb3/_next/";